import { getCurrentWallpaper, type WallpaperRef } from "@/studio/lib/wallpaper-state";

/** Wallpapers are retired. Callers still ask for a URL; there is nothing to paint. */
export function resolveWallpaperImageUrl(
  _ref: WallpaperRef = getCurrentWallpaper(),
  _appearance?: "light" | "dark",
): string | null {
  return null;
}

/** Clear any leftover wallpaper paint. Themes only change the accent. */
export function applyStudioBackgroundNow() {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.style.removeProperty("--studio-active-bg");
  root.style.removeProperty("--studio-loaded-bg");
  delete root.dataset.wallpaperKind;
  delete root.dataset.wallpaperAssetId;
  delete root.dataset.studioBgFamily;
  delete root.dataset.studioBgPack;
}
